import { IFormData } from '../../components/FormHelper/FormHelper.types';
import { IClub, ICountry, IServiceForm } from '../../types/services.types';
import instance from './axios';

export type ServiceFormProps = {
  search?: string;
  page?: number;
  limit?: number;
};

export type GetReciprocalClubProps = {
  search?: string;
  page?: number;
  limit?: number;
  country?: string;
  type?: 'all';
};

const ENDPOINTS = {
  SERVICE_FORMS: '/service-forms',
  FEEDBACKS: '/feedbacks',
  COUNTRIES: '/countries',
  RECIPROCAL_CLUBS: '/reciprocal-clubs',
};

const getServiceForms = ({ limit = 20, page = 1, ...props}: ServiceFormProps) => {
  return instance.get<{
    total: number;
    last_page: number;
    service_forms: IServiceForm[];
  }>(ENDPOINTS.SERVICE_FORMS, {
    params: {
      limit,
      page,
      ...props,
    },
  });
};

const postFeedback = (data: IFormData) => {
  return instance.post<any>(ENDPOINTS.FEEDBACKS, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    transformRequest: () => {
      return data;
  },
  });
};

const getCountries = () => {
  return instance.get<ICountry[]>(ENDPOINTS.COUNTRIES);
};

const getAllReciprocalClubs = ({type = 'all', ...props}: GetReciprocalClubProps) => {
  return instance.get<IClub[]>(ENDPOINTS.RECIPROCAL_CLUBS, {
    params: {
      type,
      ...props,
    },
  });
};

const getReciprocalClubs = ({page = 1, limit = 5, ...props}: GetReciprocalClubProps) => {
  return instance.get<{
    total: number;
    last_page: number;
    reciprocal_clubs: IClub[];
  }>(ENDPOINTS.RECIPROCAL_CLUBS, {
    params: {
      page,
      limit,
      ...props,
    },
  });
};

const ServicesApi = {
  getServiceForms,
  postFeedback,
  getCountries,
  getAllReciprocalClubs,
  getReciprocalClubs,
};

export default ServicesApi;
